import React, { useState, useEffect } from 'react'
import { Redirect, Route } from 'react-router-dom'
import {
  Button,
  notification,
  Modal,
  Empty,
  Input,
  Form,
  Row,
  Col,
  Alert
} from 'antd'
import { Loading, NewNavigation } from '..'
import Unauthorized from '../../views/Training/View/pages/Unauthorized'
import { Trans, withTranslation } from 'react-i18next'
import {
  Content,
  Main,
  SidebarExpandable,
  Wrapper
} from '../../styles'
import history from '../../history'
import { api } from '../../services'
import { useDispatch, useSelector } from 'react-redux'
import * as userActions from '../../store/actions/user'
import './style.scss'
import { styleguide } from '../../constants'
import ShareBot from '../ShareBot/ShareBot'
import ShareAssistance from '../ShareAssistance/ShareAssistance'

const { colors } = styleguide

const subTitleString = title => {
  if (title.length > 30) {
    return `${title.substring(0, 30)}...`
  }
  return title
}

const editNow = courseCloneId => {
  notification.close(courseCloneId)
  history.push(`/courses/${courseCloneId}/edit`)
}

const openNotificationWithIcon = (type = 'success', props) => {
  const {
    clearCourseCloning,
    showPopover,
    isShowPopover,
    courseCloneTitle,
    courseCloneId,
    t
  } = props
  if (isShowPopover) {
    clearCourseCloning()
    showPopover({ isShow: false, courseTitle: '', courseId: '' })

    notification[type]({
      message: courseCloneTitle,
      placement: 'bottomRight',
      duration: 10,
      key: courseCloneId,
      style: {
        width: 500,
        marginLeft: 335 - 500
      },
      description: (
        <Trans i18nKey="labels:cloning_success">
          {subTitleString(courseCloneTitle)}
        </Trans>
      ),
      btn: (
        <Button
          type="primary"
          onClick={() => {
            editNow(courseCloneId)
          }}
        >
          {t('v3:edit_now')}
        </Button>
      )
    })
  }
}

const PrivateRoute = props => {
  const [isUserDetailsCompleted, setIsUserDetailsCompleted] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(true)
  const [isJustSignedIn, setIsJustSignedIn] = useState(true)
  const [navBackground, SetNavBackground] = useState(colors.darkGreyFour)
  const user = useSelector(state => state.user)
  const organizations = useSelector(state => state.organizations.list)

  useEffect(() => {
    const activeOrgInfo = organizations?.rows?.find(
      org => user?.info?.active_organization_id === org.id
    )
    const isOrgWhiteLabelEnabeld = activeOrgInfo?.enable_white_label

    const orgHasWhiteLabelData =
      isOrgWhiteLabelEnabeld && activeOrgInfo && activeOrgInfo.white_label_data
    const headerInfo = orgHasWhiteLabelData && orgHasWhiteLabelData.header
    const headerColor = headerInfo && headerInfo.color

    const languageSelect = document.getElementById('language_select')

    const selectElement =
      languageSelect && languageSelect.querySelector('.ant-select-selection')

    if (selectElement && headerColor)
      selectElement.style.backgroundColor = headerColor
    else if (selectElement && !headerColor)
      selectElement.style.backgroundColor = '#333333'
    SetNavBackground(headerColor)
  }, [user, organizations])

  useEffect(() => {
    const {
      getUser,
      isAuthenticated,
      getOrganizations,
      getTopics,
      getOrganizationsAuto
    } = props
    const params = {
      limit: 20,
      offset: 0
    }
    if (isAuthenticated && getUser) {
      getUser()
      getOrganizations()
      getTopics()
      getOrganizationsAuto(params)
    }
  }, [])

  useEffect(() => {
    setIsJustSignedIn(props.isLogin)
  }, [props.isLogin])

  useEffect(() => {
    if (!props.isFetchingUser) {
      checkReports()
    }
  }, [props.isFetchingUser])

  useEffect(() => {
    if (props.failOrgLoad) {
      props.getOrganizations()
    }
  }, [props.failOrgLoad])

  useEffect(() => {
    window.addEventListener('focus', () => {
      const token = localStorage.getItem('accessToken')
      if (!token) {
        setIsLoggedIn(false)
      }
    })
  }, [])

  const {
    component: Component,
    isAuthenticated,
    isFetching,
    info,
    userFetchFailed,
    courseCloningProgress,
    isFetchingUser,
    isLogin,
    t,
    adminOnly,
    ...rest
  } = props


  const showingKnowledgeCenter = props.location.pathname.includes(
    '/knowledge-center'
  )

  const checkReports = () => {
    const reportsPages = props.location.pathname.includes('/reports')
    if (reportsPages) {
      if (!isFetchingUser && info.id && !info.active_organization_id) {
        history.push(`/reports/user/participant/${info.id}`)
      }
    }
  }

  const isAdmin = info.is_super_admin
    ? true
    : info.role
      ? info.role.name === 'Admin'
      : false

  const isLoggedOut = !isLoggedIn
  if (userFetchFailed || isLoggedOut) {
    return (
      <Modal
        visible={userFetchFailed || isLoggedOut}
        style={{ top: 50 }}
        bodyStyle={{ height: '90vh' }}
        footer={null}
        width="80%"
        className="information-modal"
        closable={false}
        centered
      >
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Empty
            description={
              isLoggedOut ? t('v3:sharelook_log_out') : t('v3:sorry_error')
            }
          >
            <Button type="primary" onClick={() => window.location.reload()}>
              {isLoggedOut ? t('v3:login') : t('v3:refresh_page')}
            </Button>
          </Empty>
        </div>
      </Modal>
    )
  }

  const userDetailsCompleted =
    isUserDetailsCompleted || (info.first_name && info.last_name)

  const isUser = isJustSignedIn || (showingKnowledgeCenter && !isAdmin)

  if (history.location.pathname !== '/' && isJustSignedIn) {
    setIsJustSignedIn(false)
  }

  return isAuthenticated && !isFetching ? (
    <>
      {!isFetchingUser && !userDetailsCompleted ? (
        <Modal
          visible
          style={{ top: 50 }}
          bodyStyle={{
            height: '90vh',
            background: 'linear-gradient(45deg, #f9f9f9, transparent)'
          }}
          footer={null}
          width="80%"
          className="information-modal"
          closable={false}
        >
          <div
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <RegisterFormBody
              t={t}
              userId={info.id}
              username={info.username}
              onUserSubmit={() => setIsUserDetailsCompleted(true)}
            />
          </div>
        </Modal>
      ) : (
        <Route
          {...rest}
          render={props => (
            <Wrapper>
              <Content>
                <ShareBot />
                <ShareAssistance />
                <SidebarExpandable backgroundColor={navBackground}>
                  <NewNavigation
                    isUser={isUser}
                    isKnowledgeCenter={showingKnowledgeCenter}
                  />
                </SidebarExpandable>

                <Main style={{ paddingLeft: '7rem' }} className="ssl-main-wrap">
                  <div className="ssl-main-inner">
                    {!info.id ? (
                      <Loading />
                    ) : adminOnly && !isAdmin ? (
                      <Unauthorized
                        header={false}
                        title={
                          rest.path === '/workshop'
                            ? t('v5:workshop_access_denied_title')
                            : undefined
                        }
                        subTitle={
                          rest.path === '/workshop'
                            ? t('v5:workshop_access_denied_subtitle')
                            : undefined
                        }
                      />
                    ) : (
                      (isAdmin || info.id) && <Component {...props} />
                    )}

                    {courseCloningProgress &&
                      courseCloningProgress.total ===
                      courseCloningProgress.completed &&
                      openNotificationWithIcon('success', props)}
                  </div>
                </Main>
              </Content>

              <Loading />
            </Wrapper>
          )}
        />
      )}
    </>
  ) : (
    <Redirect to="/auth/signin" />
  )
}

const RegisterForm = props => {
  const {
    form: { getFieldDecorator },
    t,
    username,
    onUserSubmit,
    userId
  } = props

  const [savingUser, setSavingUser] = useState(false)

  const dispatch = useDispatch()

  const handleSubmit = e => {
    const {
      form: { validateFields }
    } = props

    e.preventDefault()
    validateFields((err, values) => {
      if (err) return
      setSavingUser(true)

      const attributes = {
        first_name: values.firstName,
        last_name: values.lastName
      }
      api.user
        .updateDbUser(userId, attributes, attributes)
        .then(res => {
          setSavingUser(false)
          dispatch(userActions.dispatchUserNameInfo(res.data))
          onUserSubmit()
        })
        .catch(error => {
          setSavingUser(false)
        })
    })
  }

  const headerStyle = {
    margin: '3rem auto',
    fontSize: '2rem'
  }

  return (
    <Form onSubmit={handleSubmit} style={{ display: 'grid' }}>
      <svg viewBox="0 0 555 114" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M99.175,92.931 C95.459,92.931 92.083,92.931 88.486,92.931 C88.486,64.12 88.486,35.434 88.486,6.601 C91.916,6.601 95.3,6.601 98.934,6.601 C98.934,18.536 98.934,30.488 98.934,42.439 C99.101,42.517 99.268,42.594 99.434,42.672 C100.015,41.961 100.593,41.249 101.177,40.541 C109.413,30.564 124.603,29.859 132.831,39.099 C136.404,43.111 138.285,48.022 138.401,53.213 C138.695,66.36 138.499,79.518 138.499,92.862 C135.11,92.862 131.675,92.862 127.944,92.862 C127.944,87.672 127.993,82.532 127.933,77.395 C127.844,69.821 127.935,62.234 127.477,54.682 C126.947,45.957 120.355,40.431 112.558,41.644 C104.779,42.854 99.179,49.283 99.144,57.24 C99.097,68.066 99.159,78.894 99.175,89.72 C99.176,90.714 99.175,91.707 99.175,92.931 Z M554.089,92.55 C549.632,92.55 545.738,92.657 541.859,92.462 C541.043,92.421 540.103,91.399 539.526,90.607 C533.79,82.745 528.121,74.835 522.426,66.942 C521.852,66.146 521.239,65.378 520.489,64.393 C518.773,66.287 517.086,67.985 515.624,69.858 C515.139,70.478 515.084,71.546 515.08,72.41 C515.038,78.988 515.056,85.567 515.056,92.349 C511.558,92.349 508.132,92.349 504.494,92.349 C504.494,63.591 504.494,34.899 504.494,6.081 C507.961,6.081 511.346,6.081 514.978,6.081 C514.978,24.076 514.978,42.015 514.978,60.499 C519.263,55.376 523.169,50.688 527.096,46.017 C530.204,42.321 533.272,38.59 536.506,35.008 C537.223,34.213 538.543,33.614 539.619,33.559 C543.103,33.377 546.602,33.491 550.739,33.491 C543.004,41.764 535.611,49.673 528.048,57.764 C536.61,69.201 545.157,80.617 554.089,92.55 Z M16.115,113.975 C16.115,106.438 16.115,99.213 16.115,92.067 C21.317,91.049 26.502,90.34 31.513,88.988 C42.677,85.976 52.633,80.842 59.381,70.989 C64.431,63.616 65.915,55.845 60.933,47.739 C58.471,43.735 54.644,41.44 50.494,39.571 C49.83,39.272 49.181,38.936 48.531,38.604 C48.482,38.579 48.487,38.45 48.389,38.059 C59.924,40.39 70.722,43.705 76.4,55.132 C79.981,62.338 78.834,69.69 75.552,76.75 C69.937,88.825 60.418,97.211 49.302,103.981 C39.849,109.738 29.499,112.866 18.516,113.966 C17.79,114.038 17.051,113.975 16.115,113.975 Z M413.268,61.289 C413.283,58.015 412.267,53.194 409.773,48.741 C403.723,37.938 389.121,37.195 382.008,47.321 C376.014,55.854 376.058,70.155 382.104,78.633 C388.709,87.894 401.289,88.17 408.258,79.18 C411.926,74.449 413.206,68.948 413.268,61.289 Z M366.603,63.47 C366.899,52.253 370.191,42.403 380.336,36.296 C396.443,26.602 421.665,32.985 424.108,58.378 C425.144,69.151 423.191,79.112 414.725,86.553 C405.858,94.345 395.387,96.002 384.428,91.952 C373.941,88.075 368.619,79.79 367.026,68.934 C366.869,67.865 366.708,66.793 366.616,65.717 C366.552,64.973 366.603,64.22 366.603,63.47 Z M479.77,62.211 C479.794,58.034 478.774,53.131 476.204,48.616 C470.455,38.52 456.43,37.277 449.302,46.226 C442.483,54.788 442.265,70.179 448.839,78.95 C455.544,87.895 467.808,88.051 474.695,79.26 C478.389,74.544 479.687,69.053 479.77,62.211 Z M432.984,63.876 C433.449,51.75 437.001,41.661 447.79,35.755 C464.189,26.777 488.14,33.691 490.609,58.226 C491.505,67.127 490.172,75.479 484.752,82.827 C477.997,91.985 465.074,96.071 453.405,92.856 C442.643,89.891 434.778,80.482 433.537,69.086 C433.33,67.186 433.133,65.286 432.984,63.876 Z M291.122,57.016 C291.35,46.639 285.718,40.069 276.795,39.951 C267.923,39.834 260.389,47.643 260.368,57.016 C270.575,57.016 280.781,57.016 291.122,57.016 Z M301.882,65.091 C287.466,65.091 273.835,65.091 260.231,65.091 C259.239,75.097 266.437,83.937 276.195,85.075 C283.102,85.881 289.766,84.957 296.53,82.382 C297.085,84.738 297.726,86.958 298.046,89.223 C298.115,89.701 297.112,90.619 296.431,90.87 C289.941,93.262 283.196,94.039 276.325,93.629 C262.269,92.791 253.061,85.202 250.389,71.461 C248.089,59.631 249.99,48.449 258.801,39.531 C266.196,32.047 275.464,30.365 285.326,33.298 C294.72,36.091 299.176,43.487 300.941,52.58 C301.705,56.514 301.576,60.62 301.882,65.091 Z M60.977,0.148 C60.977,6.892 60.977,13.355 60.977,19.276 C53.838,21.065 46.791,22.348 40.082,24.624 C29.822,28.104 21.174,34.026 15.971,43.949 C12.555,50.466 12.087,57.196 15.049,64.077 C17.311,69.332 21.574,72.309 26.55,74.54 C27.302,74.877 28.048,75.227 28.791,75.581 C28.85,75.608 28.868,75.723 28.904,75.797 C14.195,76.509 0.116,63.265 0.001,48.792 C-0.072,39.61 3.611,31.988 9.548,25.395 C22.97,10.488 39.665,1.917 59.739,0.152 C60.064,0.123 60.394,0.148 60.977,0.148 Z M187.511,63.06 C185.076,63.06 182.913,62.888 180.787,63.095 C175.738,63.587 170.688,64.256 166.54,67.587 C163.192,70.276 162.098,73.919 162.686,78.047 C163.231,81.885 165.285,84.661 169.085,85.868 C177.291,88.473 186.812,82.156 187.468,73.557 C187.727,70.179 187.511,66.765 187.511,63.06 Z M186.9,55.552 C187.876,46.199 182.937,40.568 174.071,40.588 C168.59,40.601 163.431,42.057 158.458,44.994 C157.599,42.576 156.808,40.351 155.84,37.629 C158.702,36.451 161.422,35.057 164.301,34.203 C169.855,32.556 175.536,32.095 181.32,33.053 C190.314,34.541 196.955,41.616 197.462,51.348 C197.985,61.396 197.827,71.478 198.05,81.544 C198.133,85.276 198.454,89.005 198.675,92.89 C195.699,92.89 192.576,92.89 189.153,92.89 C188.846,90.69 188.522,88.376 188.133,85.599 C184.497,89.854 180.445,92.557 175.417,93.773 C167.055,95.796 158.734,93.178 154.668,87.109 C149.133,78.849 151.518,67.346 160.036,61.619 C166.459,57.3 173.812,56.08 181.332,55.571 C183.14,55.448 184.964,55.552 186.9,55.552 Z M315.267,92.375 C315.267,65.02 315.267,37.818 315.267,10.415 C318.726,10.415 322.169,10.415 325.927,10.415 C325.927,34.767 325.927,59.025 325.927,83.541 C337.762,83.541 349.287,83.541 360.929,83.541 C360.929,86.597 360.929,89.395 360.929,92.375 C345.811,92.375 330.702,92.375 315.267,92.375 Z M225.543,92.425 C221.815,92.425 218.508,92.425 214.842,92.425 C214.842,72.837 214.842,53.374 214.842,33.717 C217.563,33.717 220.585,33.717 224.012,33.717 C224.012,37.357 224.012,40.945 224.012,44.534 C224.209,44.565 224.408,44.596 224.606,44.627 C225.137,43.558 225.611,42.456 226.208,41.426 C229.578,35.615 234.439,32.206 241.335,32.04 C243.247,31.994 244.269,32.487 244.088,34.715 C243.888,37.19 244.042,39.695 244.042,42.332 C243.473,42.392 242.998,42.533 242.547,42.477 C232.613,41.245 226.964,48.758 226.147,56.196 C225.47,62.374 225.656,68.651 225.558,74.886 C225.478,79.966 225.542,85.048 225.543,90.129 C225.543,90.913 225.543,91.698 225.543,92.425 Z M46.071,47.743 C44.441,47.714 42.596,49.427 42.555,51.007 C42.515,52.535 44.335,54.363 45.95,54.416 C47.703,54.474 49.336,52.909 49.375,51.133 C49.414,49.355 47.874,47.775 46.071,47.743 Z M54.054,56.355 C54.053,64.706 47.198,71.541 38.821,71.545 C30.318,71.549 23.502,64.685 23.546,56.163 C23.59,47.821 30.489,41.029 38.872,41.075 C47.212,41.12 54.055,48.007 54.054,56.355 Z"
          fill="rgb(24, 144, 255)"
          fillRule="evenodd"
        />
      </svg>
      <h3 style={headerStyle}>{t('v3:just_a_moment')}</h3>
      <Alert
        message={`Hi ! ${username ? username + ',' : ''} `}
        description={t('v3:enter_lname_fname')}
        type="info"
        showIcon
      />
      <Row gutter={[16, 16]} style={{ margin: '3rem 0' }}>
        <Col md={12}>
          <Form.Item label={t('v3:first_name')} required={true}>
            {getFieldDecorator('firstName', {
              rules: [
                {
                  required: true,
                  message: t('v3:error_firstName'),
                  max: 320
                }
              ]
            })(<Input name="firstName" maxLength={320} />)}
          </Form.Item>
        </Col>
        <Col md={12}>
          <Form.Item label={t('v3:last_name')} required={true}>
            {getFieldDecorator('lastName', {
              rules: [
                {
                  required: true,
                  message: t('v3:error_lastName'),
                  max: 320
                }
              ]
            })(<Input name="lastName" maxLength={320} />)}
          </Form.Item>
        </Col>
      </Row>
      <div style={{ width: '100%', display: 'grid', placeItems: 'center' }}>
        <Button
          size="large"
          shape="round"
          type="green"
          htmlType="submit"
          loading={savingUser}
        >
          {t('v3:procced_to_sharelook')}
        </Button>
      </div>
    </Form>
  )
}

const RegisterFormBody = Form.create({ name: 'registerName' })(RegisterForm)

export default withTranslation('help_center')(PrivateRoute)
